import { ReactNode, useEffect, useRef } from "react";
import styles from "../Table.module.scss";

type TableFooterProps = {
  nCol: number;
  selectable?: boolean;
  children: ReactNode;
};
export function TableFooter({
  nCol,
  selectable,
  children,
}: TableFooterProps) {
  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (divRef.current) {
      divRef.current.style.setProperty(
        "--span-columns",
        String(nCol + (selectable ? 1 : 0))
      );
    }
  }, [nCol, selectable]);

  return (
    <div ref={divRef} className={styles.tableFooter}>
      {children}
    </div>
  );
}
